import { Box, CircularProgress, Dialog, DialogContent, Divider, Grid, IconButton } from "@mui/material"
import DialogAppBar from "../DialogAppBar"
import axiosClient from "../../lib/axios";
import { IDataDetalharProcesso } from "../../types/api/bpm/detalhar-processo";
import InfoSessao from "./Sessoes/Info";
import Descricao from "./Sessoes/Processo/Descricao";
import StepperTarefas from "./Sessoes/Processo/StepperTarefas";
import { useQuery } from "react-query";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { useModalDetalheProcesso } from "../ModalContexts/ModalDetalheProcessoContext";
import useSetParamsURL from "../../lib/useSetParamsURL";
import { IDialogContextGeneric } from "../BasicComponents/GenericModalContext";

export default function DetalheProcessoDialog({
    open,
    value,
    handleClose
}: IDialogContextGeneric<string>) {

    const { clearParamsUrl } = useSetParamsURL();
    const { closeModal } = useModalDetalheProcesso()

    //Queries e mutations
    const { data, isLoading } = useQuery({
        queryKey: ['detalhar-processo', value],
        queryFn: () => axiosClient.get("/detalhar-processo/" + value),
        keepPreviousData: true,
        enabled: !!value,
        cacheTime: 0,
        refetchInterval: (queryData) => {
            const processo: IDataDetalharProcesso | undefined = queryData?.data;
            if (!processo) return false;

            const tarefaAtivaComFormulario = processo.tarefas?.some(tarefa => {
                const naoResolvida = !tarefa.resolvida_em && !tarefa.cancelada_em;
                if (!naoResolvida) return false;

                const acaoExterna = tarefa.extras?.acao_externa;
                const isAcaoExternaAutomatica = tarefa.tipo === "Ação externa" && acaoExterna?.reprocessamento_automatico === true;

                if (isAcaoExternaAutomatica) return false;

                return tarefa.formulario || tarefa.tipo === "Condicional" || tarefa.tipo === "Condicional automática" || tarefa.tipo === "Simples";
            });

            return tarefaAtivaComFormulario ? false : 10000;
        },
        refetchIntervalInBackground: true
    });
    const dataDetalheProcesso: IDataDetalharProcesso = data?.data
    //

    //Valores CopyNorte Button
    const match = dataDetalheProcesso?.descricao.match(/Código: ([A-Za-z])(\d+)/);
    const tipo_publico = match?.[1] || '';
    const codigo_publico = match?.[2] || '';
    //
    
    const handleImprimir = () => {
        window.print(); // Abre a janela de impressão do navegador
    };

    const handleCloseDialog = () => {
        clearParamsUrl()
        handleClose();
        closeModal()
    }
    

    return (
        <Dialog
            open={open}
            onClose={handleCloseDialog}
            fullScreen
        >
            <DialogAppBar
                handleClose={handleCloseDialog}
                title={`Processo #${value}`}
                actionItems={[
                    <IconButton
                        aria-label="print"
                        onClick={handleImprimir}
                        className="hide-on-print"
                        sx={{ color: "white" }}
                    >
                        <LocalPrintshopIcon />
                    </IconButton>
                ]}
            />

            <DialogContent sx={{ overflowY: { xs: "auto", md: "hidden" }, mt: 8, height: "100%" }}>
                {
                    isLoading &&
                    <Box display="flex" justifyContent="center" my={3}>
                        <CircularProgress />
                    </Box>
                }

                {
                    !isLoading &&
                    <Grid container spacing={2} height="100%">
                        <Grid size={{ xs: 12, md: 2.5 }}> 
                            <InfoSessao
                                codigo={value}
                                usuario={dataDetalheProcesso.usuario}
                                usuario_status={dataDetalheProcesso.usuario_status}
                                perfil={dataDetalheProcesso.perfil}
                                perfil_solicitante={dataDetalheProcesso.perfil_solicitante}
                                criadoEm={dataDetalheProcesso.created_at}
                                situacao={dataDetalheProcesso.situacao}
                                arquivos={dataDetalheProcesso.arquivos}
                                tarefas={dataDetalheProcesso.tarefas}
                                tipo_publico={tipo_publico}
                                codigo_publico={codigo_publico}
                                proximo_processo={dataDetalheProcesso.proximo_processo}
                            />
                        </Grid>

                        <Grid display={'flex'} justifyContent={'center'} size={{ xs: 0, md: 0.5 }}>
                            <Divider sx={{ width: 2 }} orientation="vertical" />
                        </Grid>

                        <Grid
                            container
                            size={{ xs: 12, md: 9 }}
                            sx={{
                                height: "100%",
                                overflowY: "auto",
                                padding: 2,
                                paddingBottom: 22,
                                '@media print': {
                                    height: "100%"
                                }
                            }}
                        >
                            <Grid size={{ xs: 12}}>
                                <Descricao
                                    titulo={dataDetalheProcesso.titulo}
                                    descricao={dataDetalheProcesso.descricao}
                                />
                            </Grid>

                            <Grid size={{ xs: 12}}>
                                <StepperTarefas
                                    codigo={value}
                                    usuarioSolicitante={dataDetalheProcesso.usuario}
                                    tarefas={dataDetalheProcesso.tarefas}
                                    situacao={dataDetalheProcesso.situacao}
                                    atualizadoEm={dataDetalheProcesso.updated_at}
                                    motivoFinalizado={dataDetalheProcesso.motivo_finalizado}
                                    finalizadoPor={dataDetalheProcesso.finalizado_por}
                                    extras={dataDetalheProcesso.extras}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </DialogContent>
        </Dialog>
    )
}
